import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PlantingSiteListComponent } from './planting-site-list/planting-site-list.component';
import { ListMapComponent } from './planting-site-list/list-map/list-map.component';
import { ListGridComponent } from './planting-site-list/list-grid/list-grid.component';
import { CountriesResolverService } from '../backend/planting-site-details/countries-resolver.service';
import { FrontendComponent } from './frontend.component';
import { PlantingSitesResolverService } from '../core/services/planting-sites-resolver.service';
import { PlantingSiteDetailsComponent } from './planting-site-details/planting-site-details.component';
import { VideoDetailComponent } from './video-detail/video-detail.component';
import { PlantingSiteDetailsResolverService } from '../backend/planting-site-details/planting-site-details-resolver.service';
import { CollectionDetailComponent } from './collection-detail/collection-detail.component';
import { CollectionMapComponent } from './collection-map/collection-map.component';
import { ApplicationConfigResolverService } from '../core/services/application-config-resolver.service';
import { PlantingSiteEmbededComponent } from './planting-site-embeded/planting-site-embeded.component'; 
import { VideoDetailEmbededComponent } from './video-detail-embeded/video-detail-embeded.component';
import { CollectionDetailEmbededComponent } from './collection-detail-embeded/collection-detail-embeded.component';
import { CollectionMapEmbededComponent } from './collection-map-embeded/collection-map-embeded.component';

const routes: Routes = [
    {
        path: '',
        resolve: {
            appConfig: ApplicationConfigResolverService
        },
        component: FrontendComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: HomeComponent,
                resolve: {
                    countries: CountriesResolverService
                },
                data: {
                    showBackground: true
                }
            },
            {
                path: 'embeded',
                children: [
                    {
                        path: ':siteId/:info/:map/:timeline/:tree',
                        resolve: {
                            plantingSite: PlantingSiteDetailsResolverService
                        },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                component: PlantingSiteEmbededComponent,
                                data: {
                                    routeClass: 'no-padding-container-fluid'
                                }
                            },
                            {
                                path: 'area/:areaId',
                                pathMatch: 'full',
                                component: PlantingSiteEmbededComponent,
                                data: {
                                    routeClass: 'no-padding-container-fluid'
                                }
                            },
                            {
                                path: 'area/:areaId/:collectionId',
                                children: [
                                    {
                                        path: 'video',
                                        component: VideoDetailEmbededComponent
                                    },
                                    {
                                        path: 'detail',
                                        children: [
                                            { path: ':photoId', component: CollectionDetailEmbededComponent }
                                        ]
                                    },
                                    {
                                        path: 'map',
                                        children: [
                                            { path: ':photoId', component: CollectionMapEmbededComponent }
                                        ],
                                        data: {
                                            routeClass: 'no-padding-container-fluid'
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]          
            },
            {
                path: 'plantingSite',
                children: [
                    {
                        path: 'list',
                        component: PlantingSiteListComponent,
                        resolve: {
                            plantingSites: PlantingSitesResolverService
                        },
                        data: {
                            showYearPickerCalendar: true
                        },
                        children: [
                            {
                                path: 'map',
                                component: ListMapComponent
                            },
                            {
                                path: 'grid',
                                component: ListGridComponent,
                                data: {isGrid: true}
                            }
                        ]
                    },
                    {
                        path: ':siteId',
                        resolve: {
                            plantingSite: PlantingSiteDetailsResolverService
                        },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                component: PlantingSiteDetailsComponent,
                                data: {
                                    routeClass: 'no-padding-container-fluid'
                                }
                            },
                            {
                                path: 'area/:areaId',
                                pathMatch: 'full',
                                component: PlantingSiteDetailsComponent,
                                data: {
                                    routeClass: 'no-padding-container-fluid'
                                }
                            },
                            {
                                path: 'area/:areaId/:collectionId',
                                children: [
                                    {
                                        path: 'video',
                                        component: VideoDetailComponent
                                    },
                                    {
                                        path: 'detail',
                                        children: [
                                            {path: ':photoId', component: CollectionDetailComponent}
                                        ]
                                    },
                                    {
                                        path: 'map',
                                        children: [
                                            {path: ':photoId', component: CollectionMapComponent}
                                        ],
                                        data: {
                                            routeClass: 'no-padding-container-fluid'
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class FrontendRoutingModule {}
